import { useState } from "react";
import { Navigate } from "react-router-dom";

import { useLogout } from "#hooks/use-logout";
import { ConfirmLogoutAlert } from "#navigation/sidebar/components/confirm-logout-alert";
import { Routes } from "#navigation/routes";

export const SignOut = () => {
    const logout = useLogout();
    const [open, setOpen] = useState(true);
    return open ? (
        <ConfirmLogoutAlert
            open={true}
            message="This will log you out of the dashboard"
            close={() => setOpen(false)}
            onContinue={logout}
        />
    ) : (
        <Navigate to={Routes.SettingsAccount} />
    );
};
